/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import UiFormInner from 'components/Forms/UIFormInner'
import UiButton, { UiButtonSize, UiButtonStyle, UiButtonType } from 'components/Ui/UiButton'
import { PlusIcon } from '@heroicons/react/24/solid'
import { UiTable, UiTableBody, UiTableContainer, UiTableHead, UiTableHeaderCell } from 'components/Ui/UiTable'
import EditCompanyModalOfferList from './EditCompanyModalOfferList'
import { Offer } from 'types/entities/Offer'

interface EditCompanyModalOffersTabProps {
    offers: Offer[]
    onCreateOffer: () => void
    onOfferClick: (offer: Offer) => void
}

const EditCompanyModalOffersTab = ({ offers, onCreateOffer, onOfferClick }: EditCompanyModalOffersTabProps) => {
    const { t } = useTranslation()

    return (
        <div className={clsx('EditCompanyModalOffersTab flex-1 flex flex-col pt-4 overflow-hidden')}>
            <UiFormInner
                title={t('Offers')}
                actions={
                    <UiButton
                        onClick={onCreateOffer}
                        style={UiButtonStyle.Primary}
                        size={UiButtonSize.Small}
                        type={UiButtonType.Button}
                        icon={<PlusIcon className={clsx('w-5 h-5')} />}
                    >
                        {t('Create Offer')}
                    </UiButton>
                }
            >
                <UiTableContainer>
                    <UiTable>
                        <UiTableHead>
                            <UiTableHeaderCell align="left">{t('ID')}</UiTableHeaderCell>
                            <UiTableHeaderCell align="left">{t('Offer number')}</UiTableHeaderCell>
                            <UiTableHeaderCell align="left">{t('Event date')}</UiTableHeaderCell>
                            <UiTableHeaderCell align="left">{t('Status')}</UiTableHeaderCell>
                            <UiTableHeaderCell align="left">{t('Package')}</UiTableHeaderCell>
                            <UiTableHeaderCell align="left">{t('Persons')}</UiTableHeaderCell>
                            <UiTableHeaderCell align="left">{t('Value')}</UiTableHeaderCell>
                            <UiTableHeaderCell align="left">{t('Seller')}</UiTableHeaderCell>
                            <UiTableHeaderCell align="left">{t('Has reservation')}</UiTableHeaderCell>
                            <UiTableHeaderCell align="left">{t('Valid until')}</UiTableHeaderCell>
                        </UiTableHead>
                        <UiTableBody className={clsx('EditCompanyModalOfferList')}>
                            <EditCompanyModalOfferList
                                offers={offers}
                                onClick={onOfferClick}
                            />
                        </UiTableBody>
                    </UiTable>
                </UiTableContainer>
            </UiFormInner>
        </div>
    )
}

export default EditCompanyModalOffersTab
